import { FunctionComponent, useState } from 'react';
import { FieldGroupStyled } from './styled';
import { Form } from 'react-bootstrap';
import { emptyString } from '~/constants/string';

export enum FieldGroupType {
  text = 'text',
  email = 'email',
  password = 'password',
}

export interface FieldGroupProps {
  label?: string;
  value?: string | number;
  type?: keyof typeof FieldGroupType;
  onChange?: Function;
  disabled?: boolean;
  placeholder?: string;
  as?: 'input' | 'textarea';
  className?: string;
  autoComplete?: string;
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const FieldGroup: FunctionComponent<FieldGroupProps> = ({
  onChange,
  disabled = false,
  value = emptyString,
  label = emptyString,
  placeholder = emptyString,
  type = FieldGroupType.email,
  as = 'input',
  className = emptyString,
  autoComplete = emptyString,
  onKeyPress = () => {},
}) => {
  const [inputValue, setInputValue] = useState(value);

  const onBlur = () => {
    if (!onChange) {
      return;
    }

    onChange(inputValue);
  };

  const onChangeValue = (event: any) => {
    if (!onChange) {
      return;
    }

    setInputValue(event.target.value);
    onChange(event.target.value);
  };

  return (
    <FieldGroupStyled className={className}>
      {label && <Form.Label> {label} </Form.Label>}
      <Form.Control
        as={as}
        type={type}
        value={inputValue}
        disabled={disabled}
        onChange={onChangeValue}
        onBlur={() => onBlur()}
        placeholder={placeholder}
        autoComplete={autoComplete}
        onKeyPress={onKeyPress}
      ></Form.Control>
    </FieldGroupStyled>
  );
};

export default FieldGroup;
